import React, { FC, useMemo } from 'react'

import { Toggle } from '@style-port/roov-ui-components-react'
import { Tooltip, Txt } from 'src/components/atoms'

import { useCompanyAuthMethod, useError, useGlobalLoading, useToast } from 'src/hooks'
import { CompanyEntity } from 'src/types'

type Props = {
  company: CompanyEntity
  afterUpdate: () => void
  className?: string
}

export const PasswordAuthToggle: FC<Props> = ({ company, afterUpdate, className }) => {
  const { showGlobalLoading, hideGlobalLoading } = useGlobalLoading()
  const { updateCompanyAuthMethod } = useCompanyAuthMethod()
  const { toErrorEntities } = useError()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const handleOnChange = async (isNewValue: boolean) => {
    showGlobalLoading()

    try {
      await updateCompanyAuthMethod(company.id, {
        isIDPassEnabled: isNewValue,
        isSAMLEnabled: company.isSAMLEnabled,
      })
      displayStandardTextToast('IDとパスワードでログインを更新しました')
      afterUpdate()
    } catch (error) {
      const errors = toErrorEntities(error)
      console.log('errors: ', errors)
      displayErrorTextToast('IDとパスワードでログインの更新に失敗しました')
    } finally {
      hideGlobalLoading()
    }
  }

  const isDisabledToggle = useMemo(
    () => company.isIDPassEnabled && !company.isSAMLEnabled,
    [company.isIDPassEnabled, company.isSAMLEnabled]
  )

  return (
    <div className={className}>
      <div className="tw-centering">
        <Txt className="tw-mr-s-1 tw-font-bold tw-text-roovPrimary-default">
          パスワードでログインを許可
        </Txt>
        <Tooltip
          text="パスワードでのログイン、SAML認証どちらかは有効にする必要があります"
          showIcon={false}
          disabled={!isDisabledToggle}
        >
          <Toggle
            enabled={company.isIDPassEnabled}
            onChange={handleOnChange}
            disabled={isDisabledToggle}
          />
        </Tooltip>
      </div>
    </div>
  )
}
